import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import { Field, FieldArray, formValueSelector, reduxForm, } from 'redux-form';
import {
    renderField,
    renderFieldCheck,
    renderCurrency,
    renderDatePicker
} from '../../../Utils/renderField/renderField';
import { RenderCurrency, RenderDollar, RenderKilogramo } from 'Utils/renderField/renderReadField';
import CardEmpty from "Utils/Cards/CardEmpty";
import moment from "moment/moment";
import { FACTURA_ESPECIAL, PEQUEÑO_CONTRIBUYENTE, PAGOS_DIRECTOS, PAGOS_TRIMESTRALES, EXPORTADOR, PRODUCCION_INTERNA, FLETE_INTERNO_COSTO_POR_KG } from "../../../../../utility/constants";
import { RenderCambio, RenderNumberPercentage } from '../../../Utils/renderField/renderReadField';
import RecepcionesNH3 from './RecepcionesBonificacion/RecepcionesNH3';
import RecepcionesFletes from './RecepcionesBonificacion/RecepcionesFletes';
import { getBonoNH3, getBonoFletes, calcularBonoNH3, calcularBonoFletes, hayRecepcionLatex, esRecepcionLatex, hayRecepcionSolido } from '../Utils/BonificacionRecepciones';
import './LiquidacionesForm.css';
import TotalesBonificacion from './TotalesBonificacions';
import { redondearDecimales } from '../../../../../utility/utils';

export const renderDatosCompras = (props) => {
    const { fields, cambio_dolar, hayRecepcionesLatex } = props;

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='mx-3 my-2 mb-4'>
                    <div className="new-table-wrapper liquidaciones-crear__table-wrapper">
                        <table >
                            <thead>
                                <tr>
                                    <th />
                                    <th>ID INGRESO</th>
                                    <th>FECHA</th>
                                    <th>MATERIA PRIMA</th>
                                    <th className="text-right">KILOS HUMEDOS</th>
                                    <th className="text-right">DRC</th>
                                    <th className="text-right">KILOS SECOS</th>
                                    <th className="text-right">PRECIO</th>
                                    <th className="text-right th--no-wrap">SUBTOTAL $.</th>
                                    <th className="text-right">CAMBIO</th>
                                    <th className="text-right th--no-wrap">SUBTOTAL Q.</th>
                                    {props.item && props.item.finca && props.item.finca.aplica_bonif_amoniaco && hayRecepcionesLatex && (
                                        <th className="text-right">BONO NH3</th>
                                    )}
                                    <th className="text-right">BONO FLETE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields.map((pago, index) => {
                                    const dato_actual = fields.get(index);
                                    let todos = fields.getAll();
                                    {/* Se suma el costo_flete al precio_unitario */ }
                                    const { precio_venta = 0, costo_flete = 0, tipo_costo_flete = 0 } = dato_actual;
                                    const total_precio_venta = precio_venta + (tipo_costo_flete === FLETE_INTERNO_COSTO_POR_KG ? costo_flete : 0);

                                    let tachadoClassName = '';
                                    if (dato_actual.activo !== undefined && dato_actual.activo === false) {
                                        tachadoClassName = 'tachado';
                                    }

                                    return (
                                        <tr key={index} >
                                            <td >
                                                <Field name={`${pago}.liquidar`} component={renderFieldCheck} />
                                            </td>
                                            <td label="ID INGRESO"
                                                className={`${tachadoClassName}`}>
                                                <span>{dato_actual && dato_actual.ingreso ? dato_actual.ingreso.id : '--'} </span>
                                            </td>
                                            <td label="FECHA"
                                                className={`${tachadoClassName}`}>
                                                <span>{dato_actual && dato_actual.ingreso ? moment(dato_actual.ingreso.fecha_entrada).format('DD/MM/YYYY') : '--'} </span>
                                            </td>
                                            <td label="MATERIA PRIMA"
                                                className={`${tachadoClassName}`}>
                                                <span>{dato_actual && dato_actual.materia_prima ? dato_actual.materia_prima.nombre : '--'} </span>
                                            </td>
                                            <td label="KILOS HUMEDOS"
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderKilogramo value={
                                                    dato_actual && dato_actual.kilos_humedos ? (dato_actual.kilos_humedos) : 0
                                                } />
                                            </td>
                                            <td label="DRC"
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderNumberPercentage value={dato_actual ? dato_actual.drc_compra : '--'} />
                                            </td>
                                            <td label="KILOS SECOS"
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderKilogramo value={
                                                    dato_actual && dato_actual.kilos_secos ? (dato_actual.kilos_secos) : 0
                                                } />
                                            </td>
                                            <td label="PRECIO"
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderDollar value={total_precio_venta} decimalScale={3} />
                                            </td>
                                            <td label="SUBTOTAL $."
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderDollar value={dato_actual && dato_actual.total_dolares ? dato_actual.total_dolares : 0} />
                                            </td>
                                            <td label="CAMBIO"
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderCambio value={dato_actual.cambio_dia} decimalScale={5} />
                                            </td>
                                            <td label="SUBTOTAL Q."
                                                className={`${tachadoClassName} text-right td--no-wrap`}>
                                                <RenderCurrency value={dato_actual && dato_actual.total_quetzales ? dato_actual.total_quetzales : 0} />
                                            </td>
                                            {props.item && props.item.finca && props.item.finca.aplica_bonif_amoniaco && hayRecepcionesLatex && (
                                                <td label="BONO NH3"
                                                    className="text-right td--no-wrap">
                                                    {getBonoNH3(dato_actual, false, cambio_dolar)}
                                                </td>
                                            )}
                                            <td label="BONO FLETE"
                                                className="text-right td--no-wrap">
                                                {getBonoFletes(dato_actual, false, cambio_dolar)}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
};

export const renderInsumos = ({ fields }) => {
    return (
        <div className="col-12 text-center pl-0">
            <div className="react-bs-table-container">
                <div className="react-bs-table">
                    <div className="react-bs-container-header table-header-wrapper">
                        <table className="table table-hover table-bordered">
                            <tbody>
                                <tr>
                                    <th style={{ width: "10%" }} />
                                    <th style={{ width: "25%" }}>FECHA</th>
                                    <th style={{ width: "40%" }}>NO. FACTURA</th>
                                    <th style={{ width: "25%" }}>MONTO</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <table className="table table-striped table-bordered table-hover">
                <tbody>
                    {fields.map((pago, index) => {
                        const dato_actual = fields.get(index); // Pago actual
                        let todos = fields.getAll();
                        todos[index]['index'] = index; //Mutar cada fila par agregarle el index
                        return (
                            <tr key={index}>
                                <td style={{ width: "10%" }} className="pl-0 pt-2">
                                    <Field name={`${pago}.pagar_insumo`} component={renderFieldCheck} />
                                </td>
                                <td style={{ width: "25%" }}>
                                    <span>{dato_actual ? moment(dato_actual.fecha_apli).format("DD/MM/YYYY") : ""} </span>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <span>{dato_actual ? dato_actual.no_factura : ""} </span>
                                </td>
                                <td style={{ width: "25%" }}>
                                    <RenderCurrency value={dato_actual ? dato_actual.importe : 0} />
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
};

let LiquidacionesForm = props => {
    const { handleSubmit, item, mostrar_liquidacion, ordenCompraTemp, tipo_drc, fecha_final_liq, fecha_inicio_liq, clearIndexValidados,
        total_dolares, total_quetzales, kilos_secos_liquidar, kilos_humedos_liquidar, retencion_iva, retencion_isr, total_liquidar, retencion_peq_contribuyente, total_insumos } = props;

    const { total_bonif_nh3, total_bonif_fletes, total_bonificaciones, total_bonificaciones_quetzales } = props;

    const hayRecepcionesSolido = hayRecepcionSolido(item);
    const hayRecepcionesLatex = hayRecepcionLatex(item);
    const recepcionesLatexSeleccionadas = props.recepciones ? props.recepciones.filter(recepcion => esRecepcionLatex(recepcion)) : [];

    const mostrarTablaNH3 = (hayRecepcionesSolido && recepcionesLatexSeleccionadas.length > 0) || !hayRecepcionesSolido;

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container">
                <div className="d-flex  justify-content-center mb-4">
                    <div className="col-8">
                        <div className="row col-12">
                            <h6 className="mb-4">DATOS GENERALES DE RECEPCIÓN</h6>
                        </div>
                        <div className="row col-12 col-md-12 p-0">
                            <div className="col-md-6 p-0">
                                <div className="col-12 d-flex flex-column">
                                    <label className="p-0 m-0">FECHA INICIO</label>
                                    <span className="mb-1">{moment(fecha_inicio_liq).format("DD/MM/YYYY")}</span>
                                    <label className="p-0 m-0">FECHA FINAL</label>
                                    <span className="mb-1">{moment(fecha_final_liq).format("DD/MM/YYYY")}</span>
                                    <label className="p-0 m-0">RETIENE IVA</label>
                                    <span className="mb-1">{item && item.finca && item.finca.retenedor_iva ? "SI" : "NO"}</span>
                                </div>
                            </div>
                            <div className="col-md-6 p-0">
                                <div className="col-12 d-flex flex-column">
                                    <label className="p-0 m-0">FINCA</label>
                                    <span className="mb-1">{item ? (item.finca ? item.finca.nombre : " ") : " "}</span>
                                    <label className="p-0 m-0">RÉGIMEN</label>
                                    <span className="mb-1">{item ? (item.finca ? item.finca.regimen_fiscal_nombre : (item.detalles && item.detalles[0].orden_compra.regimen_fiscal !== 0 ? item.detalles[0].regimen_fiscal_compra : ' ')) : ' '}</span>
                                    {/* <span className="mb-1">{item ? item.finca.regimen_fiscal_nombre : ' '}</span> */}
                                    {/* <span className="mb-1">{item ? (item.detalles  && item.detalles[0].orden_compra.regimen_fiscal !== 0 ? item.detalles[0].regimen_fiscal_compra : (item.finca ? item.finca.regimen_fiscal_nombre : " ") ) : " "}</span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <FieldArray name="detalles" component={renderDatosCompras} {...props} hayRecepcionesLatex={hayRecepcionesLatex} />
                    </div>
                </div>

                {/* SECCIÓN DE BONIFICACION POR USO DE AMONIACO */}
                {item && item.finca && item.finca.aplica_bonif_amoniaco && mostrarTablaNH3 && (
                    <RecepcionesNH3 recepciones={recepcionesLatexSeleccionadas} cambio_dolar={props.cambio_dolar} />
                )}
                {/* SECCIÓN DE BONIFICACION POR COSTO DE FLETE */}
                {item && item.finca && item.finca.aplica_bonif_fletes === true && (
                    <RecepcionesFletes recepciones={props.recepciones} cambio_dolar={props.cambio_dolar} />
                )}

                {/* <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                                PARTE DE TOTALES
                >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}

                <div className="row">
                    <div className="col-12">
                        <CardEmpty noShadow noPadding>
                            <div className="row col-12 m-0 py-3">
                                <div className="row col-1"></div>
                                <div className="row col-10 p-0">
                                    <h6 className="">TOTALES</h6>
                                </div>
                            </div>
                            {/* TODO: Ahora se evalúa si la finca retiene impuestos */}
                            {/* {item && item.finca && item.finca.retenedor_iva === false && (
                                <div className="col-12 d-flex justify-content-center align-items-center">
                                    <Alerta texto="El valor de IVA reflejado en el formulario no afecta al pago de la liquidación."/>
                                </div>
                            )} */}
                            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mb-4">
                                <div className="row col-12 col-md-10 d-flex flex-wrap justify-content-center align-items-end">
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="retencion_peq_contribuyente" className="m-0">RETENCIÓN PEQ. CONTRIBUYENTE</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="retencion_peq_contribuyente" component={renderCurrency} disabled type="text" className="form-control"
                                                input={{ value: retencion_peq_contribuyente }} decimalScale={2} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="retencion_iva" className="m-0">RETENCIÓN IVA</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="retencion_iva" component={renderCurrency} disabled type="text" className="form-control"
                                                input={{ value: retencion_iva }} decimalScale={2} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="retencion_isr" className="m-0">RETENCIÓN ISR</label>
                                        </div>
                                        <div className="col-md-12  form-group">
                                            <Field name="retencion_isr" component={renderCurrency} disabled type="text" className="form-control"
                                                input={{ value: retencion_isr }} decimalScale={2} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-4 mb-4">
                                <div className="row col-12 col-md-8 d-flex flex-wrap justify-content-center align-items-end">
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="kilos_humedos" className="m-0">KILOS HUMEDOS</label>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <h6 className="mb-1 ml-3 gris"><b>{redondearDecimales(kilos_humedos_liquidar, 2) + " kilos"}</b></h6>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="kilos_secos" className="m-0">KILOS SECOS</label>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <h6 className="mb-1 ml-3 gris"><b>{redondearDecimales(kilos_secos_liquidar, 2) + " kilos"}</b></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-4 mb-4">
                                <div className="col-12 col-md-8 d-flex flex-wrap justify-content-center align-items-end">
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="total_dolares" className="m-0">TOTAL DÓLARES</label>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <h6 className="mb-1 ml-3 gris"><b>{<RenderDollar value={total_dolares - total_bonificaciones} />}</b></h6>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="total_quetzales" className="m-0">TOTAL QUETZALES</label>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <h6 className="mb-1 ml-3 gris"><b>{<RenderCurrency value={total_quetzales - total_bonificaciones_quetzales} />}</b></h6>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 col-md-4 p-0">
                                        <div className="col-md-12 col-sm-12">
                                            <label htmlFor="total_liquidar" className="m-0">TOTAL A LIQUIDAR</label>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <h6 className="mb-1 ml-3 gris"><b>{<RenderCurrency value={total_liquidar - total_insumos} />}</b></h6>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            {/* TOTALES DE BONIFICACION */}
                            <TotalesBonificacion
                                total_bonif_nh3={total_bonif_nh3}
                                total_bonif_fletes={total_bonif_fletes}
                                total_bonificaciones={total_bonificaciones}
                                total_dolares={total_dolares}
                                total_quetzales={total_quetzales}
                                cambio_dolar={props.cambio_dolar}
                                aplica_bonif_amoniaco={item && item.finca && item.finca.aplica_bonif_amoniaco && mostrarTablaNH3}
                                aplica_bonif_fletes={item && item.finca && item.finca.aplica_bonif_fletes}
                            />

                            {/* TOTAL LIQUIDAR */}
                            <div className="row col-12 m-0 py-1 d-flex flex-wrap justify-content-center mt-2 mb-4">
                                <div className="liquidaciones-crear__total-liquidacion">
                                    <label htmlFor="total_liquidar" className="m-0">TOTAL A LIQUIDAR</label>
                                    <h6 className="mb-1 gris"><b>{<RenderCurrency value={total_liquidar - total_insumos} />}</b></h6>
                                </div>
                            </div>
                        </CardEmpty>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg-8 mt-4">
                        <CardEmpty noShadow >
                            <div className="col-12 text-center pr-0">
                                <h6 className="">VENTAS DE SAE</h6>
                            </div>
                            <div className="col-12 pr-0">
                                <FieldArray name="insumos" component={renderInsumos} {...props} />
                            </div>
                            <div className="col-12 text-right pr-0">
                                <div className="col-md-12 col-sm-12">
                                    <label htmlFor="total_insumos" className="m-0">TOTAL DE INSUMOS</label>
                                </div>
                                <div className="col-md-12 mt-2 mb-3">
                                    <h6 className="mb-1 ml-3 gris"><b>{<RenderCurrency value={total_insumos} />}</b></h6>
                                </div>
                            </div>
                        </CardEmpty>
                    </div>
                    <div className="col-12 col-lg-4 mt-4">
                        <CardEmpty noShadow>
                            <div className="col-12 d-flex justify-content-center mb-2 mt-2 m-0">
                                <div className="col-12 col-md-12">
                                    <div className="col-md-12 col-sm-12">
                                        <label htmlFor="fecha_factura" className="m-0">FECHA DE FACTURA</label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <Field
                                            name="fecha_factura"
                                            component={renderDatePicker}
                                            todayButton="Hoy"
                                            disabled={item.posee_factura === true ||
                                                (item ? (item.finca ? item.finca.regimen_fiscal === FACTURA_ESPECIAL || item.finca.regimen_fiscal === EXPORTADOR || item.finca.regimen_fiscal === PRODUCCION_INTERNA : "") : "") ? true : false}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-center mb-2 mt-2 m-0">
                                <div className="col-12 col-md-12">
                                    <div className="col-md-12 col-sm-12">
                                        <label htmlFor="serie" className="m-0">SERIE DE FACTURA</label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <Field name="serie" disabled={item ? (item.finca ? (item.finca.regimen_fiscal === FACTURA_ESPECIAL || item.finca.regimen_fiscal === EXPORTADOR || item.finca.regimen_fiscal === PRODUCCION_INTERNA ? true : false) : false) : false} component={renderField} type="text" className="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-center mb-2 mt-2 m-0">
                                <div className="col-12 col-md-12">
                                    <div className="col-md-12 col-sm-12">
                                        <label htmlFor="numero_factura" className="m-0">NO. FACTURA</label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <Field name="numero_factura" disabled={item ? (item.finca ? (item.finca.regimen_fiscal === FACTURA_ESPECIAL || item.finca.regimen_fiscal === EXPORTADOR || item.finca.regimen_fiscal === PRODUCCION_INTERNA ? true : false) : false) : false} component={renderField} type="text" className="form-control" />
                                    </div>
                                </div>
                            </div>

                        </CardEmpty>
                    </div>
                </div>
                <div className="buttons-box mt-5">
                    <Link className="btn btn-outline-dark mr-5" to="/liquidaciones">
                        CANCELAR
                    </Link>
                    <button type="submit" className="btn btn-primary">
                        LIQUIDAR
                    </button>
                </div>
            </div>
        </form>
    )
};

LiquidacionesForm = reduxForm({
    form: 'LiquidacionesForm'
})(LiquidacionesForm);

const selector = formValueSelector('LiquidacionesForm');
LiquidacionesForm = connect(state => {
    const form = state.form.LiquidacionesForm;
    const VARIABLES = state.configuracion.configuraciones.variables_calculo_impuestos;
    let total_dolares = 0;
    let total_quetzales = 0;
    let valor_factura_sin_iva = 0;
    let valor_factura = 0;
    let total_temp = 0;
    let total_temp_isr = 0;
    let total_liquidar = 0;
    let total_insumos = 0;

    // bonificaciones
    let total_bonif_nh3 = 0;
    let total_bonif_fletes = 0;
    let total_bonificaciones = 0;
    let total_bonificaciones_quetzales = 0;

    let kilos_secos_liquidar = 0;
    let kilos_humedos_liquidar = 0;

    let retencion_iva = 0;
    let descuento_iva = 0;
    let iva_materia_prima = 0;

    let retencion_isr = 0;
    let retencion_isr_pagos_directos = 0;
    let retencion_peq_contribuyente = 0;

    let isr_materia_prima = 0;
    let isr_materia_prima_restante = 0;

    // cambio de dólar
    const configuraciones = state.configuracion.configuraciones;
    let cambio_dolar = 0;
    if (configuraciones && configuraciones.cambio_dolar) {
        cambio_dolar = configuraciones.cambio_dolar.cambio_dolar;
    }

    if (form && form.values) {
        const values = form.values;
        let finca = values.finca;
        const detalles = values.detalles;
        const insumos = values.insumos;
        let total_fletes_quetzales = 0;
        const oden_compra = detalles[0].orden_compra;
        // finca.regimen_fiscal = oden_compra.regimen_fiscal !== 0 ? oden_compra.regimen_fiscal : finca.regimen_fiscal;
        // Iniciando valores para cálculo de impuestos
        form.values.retencion_iva = 0;
        form.values.retencion_isr = 0;
        form.values.retencion_peq_contribuyente = 0;

        for (let i = 0; i < detalles.length; i++) {

            if (detalles[i].liquidar) {
                total_dolares += detalles[i].total_dolares;
                total_quetzales += detalles[i].total_quetzales;
                kilos_secos_liquidar += detalles[i].kilos_secos;
                kilos_humedos_liquidar += detalles[i].kilos_humedos;

                total_bonif_nh3 += calcularBonoNH3(detalles[i]).bono_recibido;
                total_bonif_fletes += calcularBonoFletes(detalles[i]).bono_recibido;

                // form.values.total_dolares = total_dolares;
                // form.values.total_quetzales = total_quetzales;
                form.values.kilos_secos_liquidar = kilos_secos_liquidar;
                form.values.kilos_humedos_liquidar = kilos_humedos_liquidar;
                if (detalles[i].tipo_costo_flete === FLETE_INTERNO_COSTO_POR_KG) {
                    total_fletes_quetzales += detalles[i].costo_flete * detalles[i].kilos_secos * detalles[i].cambio_dia;
                }
            }
            form.values.total_fletes = total_fletes_quetzales;

        }

        if (insumos) {
            for (let i = 0; i < insumos.length; i++) {
                if (insumos[i].pagar_insumo) {
                    total_insumos += insumos[i].importe;
                }
            }
            form.values.total_insumos = total_insumos;
        }

        // total de bonificaciones
        total_bonificaciones = redondearDecimales(total_bonif_nh3 + total_bonif_fletes, 4);
        // No se utiliza el total redondeado en dolares para que coincida con SAE
        total_bonificaciones_quetzales = redondearDecimales((total_bonif_nh3 + total_bonif_fletes) * cambio_dolar, 4);

        // agregar bonificaciones al total
        total_dolares = total_dolares + total_bonificaciones;
        total_quetzales = total_quetzales + total_bonificaciones_quetzales;

        valor_factura = total_quetzales;
        valor_factura_sin_iva = valor_factura / (1 + VARIABLES['PORCENTAJE_NORMAL_IVA']);

        if (finca && finca.retenedor_iva === true) {
            /*
                valor_factura = Total de la liquidación en quetzales.
                valor_factura_sin_iva = Total de la liquidación sin iva por lo cual se hace la operación de: "valor_factura/1.12"
            */
            if (finca.regimen_fiscal === PEQUEÑO_CONTRIBUYENTE) {
                if (valor_factura > VARIABLES['REGIMEN_PEQUENIO_CONTRIBUYENTE']['MONTO_MINIMO_BASE']) {
                    iva_materia_prima = valor_factura * VARIABLES['REGIMEN_PEQUENIO_CONTRIBUYENTE']['PORCENTAJE_DESCUENTO_IVA'];
                    retencion_peq_contribuyente = iva_materia_prima;
                }
                form.values.retencion_peq_contribuyente = retencion_peq_contribuyente;
            }
            if (finca.regimen_fiscal === FACTURA_ESPECIAL) {
                iva_materia_prima = valor_factura_sin_iva * VARIABLES['REGIMEN_FACTURA_ESPECIAL']['PORCENTAJE_DESCUENTO_IVA'];
                isr_materia_prima = valor_factura_sin_iva * VARIABLES['REGIMEN_FACTURA_ESPECIAL']['PORCENTAJE_DESCUENTO_ISR'];

                retencion_iva = iva_materia_prima;
                retencion_isr = isr_materia_prima;

                form.values.retencion_iva = retencion_iva;
                form.values.retencion_isr = retencion_isr;
            }
            if (finca.regimen_fiscal === PAGOS_TRIMESTRALES) {
                if (valor_factura > VARIABLES['REGIMEN_PAGOS_TRIMESTRALES']['MONTO_MINIMO_BASE']) {
                    iva_materia_prima = valor_factura_sin_iva * VARIABLES['REGIMEN_PAGOS_TRIMESTRALES']['PORCENTAJE_DESCUENTO_IVA'];
                    descuento_iva = iva_materia_prima * VARIABLES['REGIMEN_PAGOS_TRIMESTRALES']['PORCENTAJE_DESCUENTO_RETENCION_IVA'];

                    retencion_iva = descuento_iva;
                }
                form.values.retencion_iva = retencion_iva;
            }
            if (finca.regimen_fiscal === PAGOS_DIRECTOS) {
                if (valor_factura > VARIABLES['REGIMEN_PAGOS_DIRECTOS']['MONTO_MINIMO_BASE']) {
                    // Calculo del IVA
                    iva_materia_prima = valor_factura_sin_iva * VARIABLES['REGIMEN_PAGOS_DIRECTOS']['PORCENTAJE_DESCUENTO_BASE_IVA'];
                    descuento_iva = iva_materia_prima * VARIABLES['REGIMEN_PAGOS_DIRECTOS']['PORCENTAJE_DESCUENTO_BASE_RETENCION_IVA'];

                    // Calculo del ISR
                    if (valor_factura_sin_iva >= VARIABLES['REGIMEN_PAGOS_DIRECTOS']['MONTO_MINIMO_SUPERIOR']) {
                        total_temp_isr = valor_factura_sin_iva - VARIABLES['REGIMEN_PAGOS_DIRECTOS']['MONTO_MINIMO_SUPERIOR'];

                        isr_materia_prima = VARIABLES['REGIMEN_PAGOS_DIRECTOS']['MONTO_MINIMO_SUPERIOR'] * VARIABLES['REGIMEN_PAGOS_DIRECTOS']['PORCENTAJE_DESCUENTO_MONTO_SUPERIOR_ISR'];
                        isr_materia_prima_restante = total_temp_isr * VARIABLES['REGIMEN_PAGOS_DIRECTOS']['PORCENTAJE_DESCUENTO_MONTO_RESTANTE_ISR'];
                        retencion_isr = isr_materia_prima + isr_materia_prima_restante;
                    }
                    else {
                        isr_materia_prima = valor_factura_sin_iva * VARIABLES['REGIMEN_PAGOS_DIRECTOS']['PORCENTAJE_DESCUENTO_MONTO_SUPERIOR_ISR'];
                        retencion_isr = isr_materia_prima;
                    }

                    retencion_iva = descuento_iva;
                    retencion_isr_pagos_directos = parseFloat(retencion_isr);
                }

                form.values.retencion_iva = retencion_iva;
                form.values.retencion_isr = retencion_isr;
            }
            if (finca.regimen_fiscal === EXPORTADOR) {
                form.values.retencion_iva = retencion_iva;
                form.values.retencion_isr = retencion_isr;
            }
            if (finca.regimen_fiscal === PRODUCCION_INTERNA) {
                form.values.retencion_iva = retencion_iva;
                form.values.retencion_isr = retencion_isr;
            }
        }

        total_liquidar = parseFloat(valor_factura) - parseFloat(retencion_iva) - parseFloat(retencion_isr) - parseFloat(retencion_peq_contribuyente)
        form.values.total_liquidar = total_liquidar;

        // guadar los valores en form para que se envíen en el request
        form.values.total_dolares = total_dolares;
        form.values.total_quetzales = total_quetzales;

        form.values.total_bonificaciones = total_bonificaciones;
        form.values.total_bonificaciones_quetzales = total_bonificaciones_quetzales;

        form.values.total_bonificaciones_nh3 = total_bonif_nh3;
        form.values.total_bonificaciones_quetzales_nh3 = redondearDecimales(total_bonif_nh3 * cambio_dolar, 4);
        form.values.total_bonificaciones_transporte = total_bonif_fletes;
        form.values.total_bonificaciones_transporte_quetzales = redondearDecimales(total_bonif_fletes * cambio_dolar, 4);
    }

    // recepciones para bonificaciones
    let recepciones = form && form.values && form.values.detalles ? form.values.detalles : [];
    recepciones = recepciones.filter(item => item.liquidar);

    if (form && form.values && form.values) {
        form.values.recepciones = recepciones;
    }

    return {
        total_dolares,
        total_quetzales,
        kilos_secos_liquidar,
        kilos_humedos_liquidar,
        total_liquidar,
        retencion_isr,
        retencion_iva,
        retencion_peq_contribuyente,
        total_insumos,
        recepciones,
        cambio_dolar,

        total_bonif_nh3,
        total_bonif_fletes,
        total_bonificaciones,
        total_bonificaciones_quetzales,
    }
})(LiquidacionesForm);

export default LiquidacionesForm
